module.exports = __webpack_public_path__ + "img/EOTP_button_twitter.2312a9ed.svg";